import React, { Component } from "react";
import { If } from "react-extras";
import { Link } from "react-router-dom";
import "./list_view_row.scss";
import ContextMenu from "../context_menu";
import get from "lodash/get";

class ListViewRow extends Component {
  render() {
    return (
      <div
        className="list-view-row"
        onClick={e => {
          // make sure child element clicks that bubble up don't fire this.
          if (get(e, "target.className", "").includes("list-view-row")) {
            this.props.historyPush(this.props.linkTo);
          }
        }}>
        <span className="list-view-row__text-wrapper">
          <Link to={this.props.linkTo} className="list-view-row__main-text redcircle-big-link">
            {this.props.mainText}
          </Link>
          <If condition={Boolean(this.props.subText)}>
            <Link to={this.props.linkTo} className="list-view-row__sub-text subtext">
              {this.props.subText}
            </Link>
          </If>
        </span>
        <If condition={Boolean(this.props.menuItems)}>
          <ContextMenu
            pullRight={true}
            menuItems={this.props.menuItems}
            dropUp={this.props.dropUp}
            noCircle={true}
          />
        </If>
      </div>
    );
  }
}

export default ListViewRow;
